export const SUPPORT_EMAIL = 'support@hi7538.zendesk.com'
